
import Dropdown from '@/components/ui/dropdown.vue';
import WpImage from '~/components/ui/img.vue';

export default {
  name: 'Faq',

  components: {
    Dropdown,
    WpImage,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      selectedFaq: null,
      dropdownIndex: null,
      imageObject: null,
    };
  },

  computed: {
    blockStyle() {
      return {
        backgroundColor: this.data.bg_color || 'transparent',
        color: this.data.text_color || '#201f20',
      };
    },
  },

  mounted() {
    this.checkIfMobile();
  },

  methods: {
    selectFaq(i) {
      this.selectedFaq === i
        ? (this.selectedFaq = null)
        : (this.selectedFaq = i);
    },
    openCloseDropdowns(index) {
      if (this.dropdownIndex === index) {
        this.dropdownIndex = null;
      } else {
        this.dropdownIndex = index;
      }
    },
    checkIfMobile() {
      this.imageObject =
        window && window.innerWidth < 720 && this.data.image_mobile
          ? this.data.image_mobile
          : this.data.image;
    },
  },
};
